module.exports = __webpack_public_path__ + "static/media/end-blood-badge.ace7ac0d.svg";